import { Excalidraw } from "@excalidraw/excalidraw";
import { Container, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFile, updateFile } from "src/services/file.service";

// Debounce function
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

export default class DmonkExcalidraw extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            fileId: null,
            data: {
                elements: [],
                files: {}
            },
            key: Date.now() // Add a key to force re-render
        };
    }

    async componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const fileId = urlParams.get('fileId');
        this.setState({ fileId });

        // get file data from server
        let response;
        try {
            response = await getFile(fileId);
            if (response.error) {
                this.setState({
                    loaded: true,
                    data: {
                        elements: [],
                        files: {}
                    }
                });
                alert('Error loading file: ' + response.error);
                return;
            }
        } catch (error) {
            this.setState({
                loaded: true,
                data: {
                    elements: [],
                    files: {}
                }
            });
            alert('Error loading file');
            return;
        }

        this.setState({
            loaded: true,
            data: {
                elements: response?.file?.data?.elements || [],
                files: response?.file?.data?.files || {}
            },
            key: Date.now() // Update key to force re-render
        });
    }

    handleExcalidrawChange = async (elements, appState, files) => {
        try {
            await updateFile(this.state.fileId, {
                data: {
                    elements,
                    files
                }
            });
        } catch (error) {
            alert('Error saving file');
            return;
        }
    };

    render() {
        if (!this.state.fileId) {
            return <Typography variant="h4" gutterBottom>
                No file selected
            </Typography>
        }

        if (!this.state.loaded) {
            return <Typography variant="h4" gutterBottom>
                Loading...
            </Typography>
        }

        return (
            <>
                <IconButton
                    aria-label="back"
                    sx={{ px: 2 }}
                    onClick={() => {
                        // go back
                        window.history.back();
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Excalidraw
                    key={this.state.key} // Force re-render when key changes
                    initialData={this.state.data}
                    onChange={debounce(this.handleExcalidrawChange, 500)} // Capture changes
                />
            </>
        );
    }
}
